import { render, staticRenderFns } from "./Obsbox.vue?vue&type=template&id=4377ad32&"
import script from "./Obsbox.vue?vue&type=script&lang=js&"
export * from "./Obsbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports